const img = (n) => `/images/${n}.webp`;

export const TINTS = {
  lavender: "167,157,226",
  aqua: "165,230,227",
  cyan: "128,217,235",
  blue: "115,152,231",
  purple: "120,102,232",
  pink: "217,167,232",
};

export const SOURCE = { user: "Shared by user", ai: "Suggested by AI" };

export const navLinks = [
  { id: "experience", label: "Experience" },
  { id: "stories", label: "Stories" },
  { id: "connections", label: "Connections" },
  { id: "personal-ai", label: "Personal AI" },
];

export const people = {
  karna: {
    id: "karna",
    name: "Karna",
    isMe: true,
    avatar: img("avatar-karna"),
    story: { image: img("story-karna"), caption: "Sunrise run on Marine Drive", time: "1h" },
  },
  shashin: {
    id: "shashin",
    name: "Shashin",
    avatar: img("avatar-shashin"),
    story: { image: img("story-shashin"), caption: "Garba tonight at Navrang Grounds", time: "2h" },
  },
  aditi: {
    id: "aditi",
    name: "Aditi",
    avatar: img("avatar-aditi"),
    story: { image: img("story-aditi"), caption: "Found the best flat white in Bandra", time: "3h" },
  },
  aryan: {
    id: "aryan",
    name: "Aryan",
    avatar: img("avatar-aryan"),
    story: { image: img("story-aryan"), caption: "Speaking at Founders Circle tonight", time: "5h" },
  },
  riya: {
    id: "riya",
    name: "Riya",
    avatar: img("avatar-riya"),
    story: { image: img("story-riya"), caption: "Made it to the top. Worth every step.", time: "8h" },
  },
};

export const storyOrder = ["karna", "shashin", "aditi", "aryan", "riya"];

export const conversations = {
  shashin: {
    preview: "Already did. Riya and Aditi are in too.",
    time: "9:12",
    unread: 2,
    messages: [
      { id: 1, type: "text", from: "them", text: "You coming tonight? The circle starts at 9." },
      { id: 2, type: "storyReply", from: "me", story: "shashin", text: "That kurta though. Save me a spot!" },
      { id: 3, type: "text", from: "them", text: "Already did. Riya and Aditi are in too." },
      { id: 4, type: "text", from: "me", text: "On my way after work." },
    ],
  },
  aditi: {
    preview: "That little place near Carter Road? 10am?",
    time: "8:40",
    unread: 1,
    messages: [
      { id: 1, type: "text", from: "them", text: "Coffee this weekend?" },
      { id: 2, type: "text", from: "me", text: "Yes! Saturday morning works." },
      { id: 3, type: "text", from: "them", text: "That little place near Carter Road? 10am?" },
      { id: 4, type: "text", from: "me", text: "Perfect. I'll bring the film camera." },
    ],
  },
  aryan: {
    preview: "Come to the founder meetup Thursday.",
    time: "Yesterday",
    unread: 0,
    messages: [
      { id: 1, type: "text", from: "them", text: "Saw your hackathon story. What are you building?" },
      { id: 2, type: "text", from: "me", text: "A tiny tool for planning group trips." },
      { id: 3, type: "text", from: "them", text: "Come to the founder meetup Thursday. I'll introduce you to two people." },
    ],
  },
  riya: {
    preview: "Let's go together!",
    time: "Mon",
    unread: 0,
    messages: [
      { id: 1, type: "text", from: "them", text: "Back from the trek! Anything happening this weekend?" },
      {
        id: 2,
        type: "ai",
        title: "Garba night at Navrang Grounds",
        meta: "Saturday · 3 friends going",
        reason: "You and Riya both saved Navratri events",
        image: img("story-shashin"),
        cta: "View Moment",
        action: { person: "shashin", mode: "min" },
      },
      { id: 3, type: "text", from: "them", text: "Ooh yes. Let's go together!" },
    ],
  },
};

export const conversationOrder = ["shashin", "aditi", "aryan", "riya"];

export const storySteps = [
  {
    title: "Tap a story.",
    body: "Your people sit right at the top. One tap on Shashin's ring and his Garba night fills the screen.",
    state: { selected: "shashin", mode: "min", zoom: false },
  },
  {
    title: "Step into the moment.",
    body: "The story opens wide, edge to edge. No feed noise, just the moment someone chose to share.",
    state: { selected: "shashin", mode: "min", zoom: true },
  },
  {
    title: "The sheet rises.",
    body: "A deep black sheet glides up beneath the story with every conversation one swipe away.",
    state: { selected: "shashin", mode: "peek", zoom: false },
  },
  {
    title: "A conversation opens.",
    body: "Story above, chat below. You never leave the moment to talk about it.",
    state: { selected: "shashin", mode: "split", zoom: false },
  },
  {
    title: "Reply to the story.",
    body: "Replies carry the story with them, so every message keeps its context.",
    state: { selected: "shashin", mode: "expanded", zoom: false, highlight: "storyReply" },
  },
  {
    title: "Back to everyone.",
    body: "Pull the sheet down and you're back with all your people. Stay connected, without switching screens.",
    state: { selected: "shashin", mode: "peek", zoom: false },
  },
];

export const heroChips = [
  { id: "chat", kind: "chat", avatar: img("avatar-aditi"), name: "Aditi", text: "Coffee this weekend?", style: { right: "8%", top: "22vh" }, speed: -380 },
  { id: "ai", kind: "ai", text: "AI found a moment", sub: "Garba · 3 friends going", style: { left: "7%", top: "54vh" }, speed: -480 },
  { id: "reply", kind: "reply", avatar: img("avatar-shashin"), text: "Shashin replied to your story", style: { right: "11%", top: "70vh" }, speed: -300, xlOnly: true },
];

export const feedItems = [
  {
    id: "garba", image: img("feed-garba"), tint: TINTS.lavender, category: "Shared Moment", source: "user",
    title: "Garba Night", subtitle: "Shashin shared a moment", cta: "View Moment", ctaStyle: "light",
    alt: "Friends in traditional outfits dancing garba under string lights",
    description: "The whole circle came alive at Navrang Grounds. Shashin shared the night with close friends.",
    people: ["Shashin", "Riya", "Aditi"], result: "Moment saved to your memories — sample demo",
  },
  {
    id: "coffee", image: img("feed-coffee"), tint: TINTS.aqua, category: "Plan", source: "user",
    title: "Coffee with Aditi", subtitle: "A moment worth sharing", cta: "Start Chat", ctaStyle: "dark",
    alt: "Two friends laughing over coffee at an outdoor cafe",
    description: "Aditi and Tara found a quiet street cafe. Aditi wants to make it a Saturday ritual.",
    people: ["Aditi", "Tara"], result: "Chat started with Aditi — sample demo",
  },
  {
    id: "concert", image: img("feed-concert"), tint: TINTS.purple, category: "Event", source: "ai",
    title: "Indie Night Live", subtitle: "Saturday · Blue Frog", stat: "12", statLabel: "friends interested", cta: "Get Details", ctaStyle: "light",
    alt: "A crowd singing along at an indoor concert under blue stage lights",
    description: "Twelve people you know are interested in this show. Your AI thinks you'd love the opening act.",
    people: ["Jun", "Maya", "Kabir", "+9"], result: "Event details sent to your chat — sample demo",
  },
  {
    id: "founders", image: img("feed-founders"), tint: TINTS.blue, category: "Discovery", source: "ai",
    title: "Founders Circle", subtitle: "Thursday · WeWork BKC", stat: "3", statLabel: "shared interests", cta: "Explore", ctaStyle: "dark",
    alt: "Three young founders brainstorming around a table with laptops",
    description: "A small founder meetup where three attendees share your interest in travel tech.",
    people: ["Aryan", "Sara", "Neel"], result: "Added to your interests — sample demo",
  },
  {
    id: "cycling", image: img("feed-cycling"), tint: TINTS.cyan, category: "Community", source: "user",
    title: "Weekend Cycling", subtitle: "4 friends are interested", cta: "Join the Ride", ctaStyle: "light",
    alt: "Four friends cycling on a misty tree-lined road",
    description: "An easy 20km ride at sunrise, ending with breakfast. Four friends have already said maybe.",
    people: ["Riya", "Ishaan", "Ananya", "Theo"], result: "Request sent — sample demo",
  },
  {
    id: "birthday", image: img("feed-birthday"), tint: TINTS.pink, category: "Memory", source: "user",
    title: "Zara turns 25", subtitle: "A year of moments, together", cta: "Relive It", ctaStyle: "dark",
    alt: "A young woman blowing out birthday candles surrounded by friends",
    description: "Candles, terrible singing and the best people. Zara's friends put together a memory reel.",
    people: ["Zara", "Aditi", "Karna"], result: "Memory reel opened — sample demo",
  },
  {
    id: "photowalk", image: img("feed-photowalk"), tint: TINTS.lavender, category: "Activity", source: "ai",
    title: "Old City Photo Walk", subtitle: "Sunday 7am · Pink City lanes", cta: "Join Walk", ctaStyle: "light",
    alt: "A young man photographing old city streets with a film camera",
    description: "A slow morning walk through heritage lanes. Bring any camera — even your phone.",
    people: ["Kabir", "Lucia"], result: "You've joined the walk — sample demo",
  },
  {
    id: "friendship", image: img("feed-friendship"), tint: TINTS.aqua, category: "Connection", source: "ai",
    title: "Ananya & Lucia", subtitle: "You both love indie films", cta: "Say Hello", ctaStyle: "dark",
    alt: "Two young women sharing earphones and smiling on park steps",
    description: "They met at a book swap. Your AI noticed you share their taste in films and music.",
    people: ["Ananya", "Lucia"], result: "Hello sent — sample demo",
  },
  {
    id: "travel", image: img("feed-travel"), tint: TINTS.blue, category: "Plan", source: "user",
    title: "Weekend in Lonavala", subtitle: "Riya invited you + 3 others", cta: "See Plan", ctaStyle: "light",
    alt: "Friends with backpacks on a train platform ready for a trip",
    description: "Train at 7:10, monsoon trails, chai at the top. Riya is collecting a crew of five.",
    people: ["Riya", "Ishaan", "Theo", "Karna"], result: "Plan saved — sample demo",
  },
  {
    id: "skill", image: img("feed-skill"), tint: TINTS.cyan, category: "Opportunity", source: "ai",
    title: "Design × Music", subtitle: "Kabir needs a cover artist", cta: "Collaborate", ctaStyle: "dark",
    alt: "A designer and a musician collaborating in a home studio",
    description: "Kabir is finishing his first EP and needs artwork. Your AI matched your design work with his brief.",
    people: ["Kabir", "Zoya"], result: "Collaboration request sent — sample demo",
  },
  {
    id: "playlist", image: img("feed-playlist"), tint: TINTS.purple, category: "Interest", source: "user",
    title: "Late Night Vinyl", subtitle: "A playlist by Neel & Theo", stat: "28", statLabel: "tracks", cta: "Listen Together", ctaStyle: "light",
    alt: "Two friends choosing songs among vinyl records on a bedroom floor",
    description: "Neel and Theo made a shared playlist for slow Sunday nights. Add a track or press play together.",
    people: ["Neel", "Theo"], result: "Listening session started — sample demo",
  },
  {
    id: "dinner", image: img("feed-dinner"), tint: TINTS.pink, category: "Meetup", source: "user",
    title: "Terrace Supper", subtitle: "Friday 8pm", stat: "6", statLabel: "seats left", cta: "RSVP", ctaStyle: "dark",
    alt: "Friends sharing a long candlelit dinner table on a terrace at dusk",
    description: "A long-table dinner with home-style dishes and people you'll want to see again.",
    people: ["Aditi", "Aryan", "Jun", "+3"], result: "RSVP sent — sample demo",
  },
];
